import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { 
  Stethoscope, 
  Smile, 
  Activity, 
  Heart, 
  Baby, 
  Sparkles, 
  Scissors,
  Syringe
} from 'lucide-react';
import { useData } from '../context/DataContext';

const iconMap = {
  'odontologia-general': Stethoscope,
  'ortodoncia': Smile,
  'endodoncia': Activity,
  'periodoncia': Heart,
  'odontopediatria': Baby,
  'implantologia': Syringe,
  'estetica-dental': Sparkles,
  'cirugia-oral': Scissors
};

const Specialties = () => {
  const navigate = useNavigate();
  const { specialties, loading } = useData();

  if (loading || !specialties) {
    return (
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500 mx-auto"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Especialidades Dentales</h2>
          <p className="text-gray-600 text-lg">Encuentra la especialidad dental que necesitas para tu tratamiento</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialties.map((specialty) => {
            const Icon = iconMap[specialty.id] || Stethoscope;
            return (
              <Card 
                key={specialty.id}
                className="group hover:shadow-xl transition-all duration-300 cursor-pointer border-gray-200 hover:border-cyan-300 bg-white"
                onClick={() => navigate(`/clinicas?especialidad=${specialty.id}`)}
              >
                <CardContent className="p-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cyan-100 mb-4 group-hover:bg-cyan-500 transition-colors duration-300">
                    <Icon className="h-8 w-8 text-cyan-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                    {specialty.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {specialty.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Specialties;
